<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid, reset}" ref="observer">
    <artisio-modal size="lg" :visible="modal.show" :title="computedTitle" @hidden="onHidden"
                   @hide="onHide" hide-footer
                   :ok-title="$t('Submit')" :is-loading="loading" :content-in-form="false" scrollable>
      <div class="row">
        <div class="col-md-12" v-if="paymentRows && paymentRows.length > 0">
          <table class="table table-sm">
            <tr>
              <th class="border-top-0">{{ $t('ID') }}</th>
              <th class="border-top-0">{{ $t('Amount') }}</th>
              <th class="border-top-0">{{ $t('Created at') }}</th>
              <th class="border-top-0">{{ $t('Exported at / Exported by') }}</th>
              <th class="border-top-0">{{ $t('Export') }}</th>
            </tr>
            <tr v-for="(item, index) in paymentRows" :key="`manual-row-${index}`">
              <td>
                <span :class="['ml-1', 'badge', item.financial_export ? 'bg-success' : 'bg-danger',  'text-white']">
                  {{
                    item.financial_export
                      ? item.financial_export.export_no
                      : $t('Not Exported')
                  }}
                </span>
              </td>
              <td>
                <span>
                  {{ item.amount | asCurrency(settlement.currency ? settlement.currency.symbol : null) }}
                </span>
              </td>
              <td>
                <span>
                  {{ item.created_at | toDateTime }}
                </span>
              </td>
              <td>
                <span v-if="item.financial_export">
                  {{
                    item.financial_export.created_at | toDateTime
                  }} by {{ item.financial_export.created_by.display_name }}
                </span>
              </td>
              <td>
                <b-button variant="secondary" @click="onFinancialExportSettlementClick(item)"
                          v-if="item.financial_export" v-permission="'export_settlement'"
                          class="shadow-none ml-2" v-b-tooltip.hover.bottomleft="$t('Export')">
                  <font-awesome-icon icon="download" class="icon"/>
                </b-button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";
  import ExportsService from "@/core/services/exports.service";

  const {mapState, mapActions} = createNamespacedHelpers('settlements');

  export default {
    name: "SettlementPaymentExportsModal",
    components: {
      ArtisioModal,
    },
    data() {
      return {
        loading: false,
      }
    },
    computed: {
      ...mapState({
        modal: state => state.paymentExportsModal,
        settlement: state => {
          return state.paymentExportsModal.settlement
        }
      }),
      computedTitle() {
        return this.$i18n.t("Settlement Payment History")
      },
      paymentRows() {
        if (!this.settlement || !this.settlement.settlement_payments) {
          return []
        }
        return this.settlement.settlement_payments.filter(sp => !sp.payment.batch_payment || sp.payment.batch_payment.status === 'approved')
      },
    },
    methods: {
      ...mapActions(['hidePaymentExportsModal']),
      onHide() {
        this.hidePaymentExportsModal();
      },
      onHidden() {
        this.hidePaymentExportsModal();
      },
      async onFinancialExportSettlementClick(item) {
        const response = await ExportsService.exportFinancialHistory({
          uuid: item.financial_export.uuid
        })
        if (response.success) {
          this.$toast('success', this.$i18n.t('Export generation has successfully started'))
          window.open(
            response.body.url,
            '_blank'
          );
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          } else if (response.toastError) {
            this.$errorDialog(response.toastError);
          }
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  tr {
    td {
      vertical-align: middle;
    }
  }
</style>
